export default __webpack_public_path__ + "static/media/slice-slides-large.ef552f7d.jpg";